import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PhysicianActions } from '../../actions/constant';
import physicianService, {
  PhysicianDocument,
  DocumentSignatureWorkflowStatuses,
} from 'src/services/apiServices/physician-service/physician-service';

const {
  UPDATE_DOCUMENT_STATUSES_REQUEST,
  UPDATE_DOCUMENT_STATUSES_LOADING,
  UPDATE_DOCUMENT_STATUSES_SUCCESS,
  UPDATE_DOCUMENT_STATUSES_FAILURE,
} = PhysicianActions;

interface UpdateDocumentStatusesAction {
  type: typeof UPDATE_DOCUMENT_STATUSES_REQUEST;
  physicianId: string;
  physicianDocumentUuids: PhysicianDocument['uuid'][];
  physicianSignatureStatus: DocumentSignatureWorkflowStatuses;
  physicianSignature: string | null;
  pin?: string;
  consentConfirmation?: boolean;
}

function* updateDocumentStatuses(action: UpdateDocumentStatusesAction): SagaReturnType<any> {
  try {
    yield put({ type: UPDATE_DOCUMENT_STATUSES_LOADING });
    const response = yield call(
      physicianService.updateDocumentStatuses,
      action.physicianId,
      action.physicianDocumentUuids,
      action.physicianSignatureStatus,
      action.physicianSignature,
      action.pin,
      action.consentConfirmation
    );
    if (response?.status === 200) {
      yield put({ type: UPDATE_DOCUMENT_STATUSES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_DOCUMENT_STATUSES_FAILURE, payload: error });
  }
}

function* updateDocumentStatusesSaga() {
  yield takeEvery(UPDATE_DOCUMENT_STATUSES_REQUEST, updateDocumentStatuses);
}

export default updateDocumentStatusesSaga;
